module.exports = __webpack_public_path__ + "img/7.60e6f25a.jpg";